// Whitelist of affiliate names
export const WHITELISTED_AFFILIATES = [
  "Dillon",
  "Gray",
  "Jemuel",
  "Ori",
  "Zane",
  "Leaks",
  "Tarun",
  "Munsur",
  "TasDigital",
  "kam111",
  "Kiana",
  "Maai",
];

// Additional attribution patterns (checked before whitelist)
// - All ads containing "DDIAD" → Dillon
// - All ads containing "HHORG" → Dillon
// - All ads containing "DNAH" → Leaks
// - All ads containing "JSOTTO" → Jemuel
// - All ads containing "JOR" → Jemuel
// - All ads containing "TASDIGITAL" → TasDigital
// - All ads starting with "DD" → Dillon
// - All ads starting with "T" → Tarun

// Default commission percentage (4.8% of ad spend)
export const DEFAULT_COMMISSION_PERCENTAGE = 0.048;

// Pagination settings
export const ROWS_PER_PAGE = 50;

export const BRANDS = [
  { value: "holistic_hercules", label: "Holistic Hercules" },
  { value: "aphrodite", label: "Aphrodite" },
];

export const REDIRECT_URL =
  process.env.REACT_APP_REDIRECT_URL || "https://wordd-two.vercel.app";

// Domain configuration - can be overridden via environment variables
export const APP_DOMAIN = process.env.REACT_APP_DOMAIN || "olympus.com";
export const ADMIN_DOMAINS = process.env.REACT_APP_ADMIN_DOMAINS
  ? process.env.REACT_APP_ADMIN_DOMAINS.split(",")
  : ["olympus.com", "admin.com"];
